// Configuration for the application
const config = {
  // API base URL - update this according to your environment
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  
  // Other configuration options can be added here
  appName: 'Receptify',
  
  // Default headers for API requests
  defaultHeaders: {
    'Content-Type': 'application/json',
  },
  
  // LiveKit configuration
  LIVEKIT: {
    URL: process.env.REACT_APP_LIVEKIT_URL || 'wss://your-livekit-instance.com',
  },
  
  // Outbound call configuration
  OUTBOUND: {
    TRUNK_ID: process.env.REACT_APP_SIP_OUTBOUND_TRUNK_ID || 'ST_KQQg7qogBfSi',
  }
};

// Export the API_URL directly for backwards compatibility
export const API_URL = config.API_URL;

export default config;

// Also export individual config values for backwards compatibility
export const APP_VERSION = '1.0.0'; 